import { render, staticRenderFns } from "./TreatmentDetails.vue?vue&type=template&id=762d48d5&scoped=true&"
import script from "./TreatmentDetails.vue?vue&type=script&lang=js&"
export * from "./TreatmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentDetails.vue?vue&type=style&index=0&id=762d48d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762d48d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VSwitch})
